var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-pane",class:`${_vm.selected ? 'show active' : ''}`,attrs:{"id":`${_vm.tab_id_computed}`,"role":"tabpanel","aria-labelledby":`${_vm.tab_id_computed}-tab`}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }